import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GenericApiService } from '@pm-ui/core-services';

import { DbSetEndpoints } from '../../config';
import { IEntityRequestVM } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class DbSetService {
    constructor(private genericApiService: GenericApiService) { }

    getAll<T>(model: IEntityRequestVM): Observable<HttpResponse<T>> {
        return this.genericApiService.post<T>(DbSetEndpoints.GetAll, model);
    }

    save<T>(model: IEntityRequestVM): Observable<HttpResponse<T>> {
        return this.genericApiService.post<T>(DbSetEndpoints.Save, model);
    }

    update<T>(model: IEntityRequestVM): Observable<HttpResponse<T>> {
        return this.genericApiService.post<T>(DbSetEndpoints.Update, model);
    }

    delete<T>(model: IEntityRequestVM): Observable<HttpResponse<T>> {
        return this.genericApiService.post<T>(DbSetEndpoints.Delete, model);
    }
}
